var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComponentlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.052,
    height: 19.059,
    viewBox: "0 0 15.052 19.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-36.183 -800.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(30.2 800.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M28.235,15.5a.627.627,0,0,0-.032-.184c0-.011-.006-.022-.01-.032a.638.638,0,0,0-.094-.165l-.008-.014L23.7,9.762c-.006-.008-.014-.013-.021-.02a.551.551,0,0,0-.055-.054c-.014-.012-.028-.025-.042-.036a.618.618,0,0,0-.068-.042c-.015-.008-.029-.017-.045-.025a.665.665,0,0,0-.085-.03c-.014,0-.026-.009-.039-.012a.658.658,0,0,0-.13-.014H13.819a.636.636,0,0,0-.636.636V27.952a.636.636,0,0,0,.636.636H27.6a.636.636,0,0,0,.636-.636V15.5Zm-4.394-3.559,2.411,2.932H23.841ZM14.455,27.316V10.8h8.113v4.707a.636.636,0,0,0,.636.636h3.758V27.316Z",
    transform: "translate(-7.2 -9.529)",
    fill: "#005e98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(176.483 741.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M8.416,8.058H1.9a.55.55,0,0,1-.523-.422L.02,2.465A.577.577,0,0,1,0,2.361.567.567,0,0,1,.5,1.738H2.428L3.352.265a.541.541,0,0,1,.381-.26A.509.509,0,0,1,3.806,0a.518.518,0,0,1,.31.1.6.6,0,0,1,.135.8l-.525.835H6.582L6.065.9A.6.6,0,0,1,5.972.637.568.568,0,0,1,6.455.005l.053,0a.534.534,0,0,1,.456.263l.924,1.473H9.772a.5.5,0,0,1,.144.021.544.544,0,0,1,.328.27.6.6,0,0,1,.052.436L8.939,7.636A.55.55,0,0,1,8.416,8.058ZM1.266,2.887,2.318,6.909H8L9.049,2.887Z",
    transform: "translate(-138.012 66.951)",
    fill: "#005e98",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComponentlist);
export default __webpack_public_path__ + "static/media/Icon-Component list.e82ec30c8bb076102343f2665bc58853.svg";
export { ForwardRef as ReactComponent };